// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Dashboard Container */
.dashboard-container {
  padding: 20px;
  background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 25%, #e0f2fe 50%, #cffafe 75%, #dbeafe 100%);
  min-height: 100vh;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
  position: relative;
}

.dashboard-container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: 
    radial-gradient(circle at 20% 50%, rgba(59, 130, 246, 0.1) 0%, transparent 60%),
    radial-gradient(circle at 80% 20%, rgba(6, 182, 212, 0.08) 0%, transparent 55%),
    radial-gradient(circle at 40% 80%, rgba(34, 197, 94, 0.06) 0%, transparent 50%),
    radial-gradient(circle at 70% 60%, rgba(139, 92, 246, 0.07) 0%, transparent 45%);
  pointer-events: none;
}

/* Dashboard Header */
.dashboard-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  background: rgba(219, 234, 254, 0.6);
  backdrop-filter: blur(15px);
  -webkit-backdrop-filter: blur(15px);
  padding: 25px 35px;
  border-radius: 20px;
  box-shadow: 
    0 20px 40px rgba(59, 130, 246, 0.15),
    0 1px 3px rgba(59, 130, 246, 0.1);
  border: 1px solid rgba(147, 197, 253, 0.3);
  position: relative;
  z-index: 1;
}

.dashboard-header h1 {
  margin: 0;
  background: linear-gradient(135deg, #1e3a8a 0%, #1e40af 50%, #3b82f6 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-size: 2.2rem;
  font-weight: 800;
  letter-spacing: -0.5px;
  text-shadow: 0 2px 4px rgba(59, 130, 246, 0.1);
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 20px;
}

.refresh-btn {
  background: linear-gradient(135deg, #3b82f6 0%, #06b6d4 100%);
  color: white;
  border: none;
  padding: 14px 24px;
  border-radius: 14px;
  cursor: pointer;
  font-weight: 700;
  font-size: 0.95rem;
  transition: all 0.3s ease;
  box-shadow: 
    0 8px 20px rgba(59, 130, 246, 0.25),
    0 2px 4px rgba(0, 0, 0, 0.1);
  position: relative;
  overflow: hidden;
}

.refresh-btn:hover {
  transform: translateY(-3px) scale(1.02);
  background: linear-gradient(135deg, #2563eb 0%, #0891b2 100%);
  box-shadow: 
    0 12px 30px rgba(59, 130, 246, 0.35),
    0 4px 8px rgba(0, 0, 0, 0.15);
}

.date-display {
  color: #1e40af;
  font-weight: 700;
  background: rgba(147, 197, 253, 0.4);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  padding: 10px 16px;
  border-radius: 12px;
  border: 1px solid rgba(147, 197, 253, 0.3);
  font-size: 0.9rem;
}

/* Stats Grid */
.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}

.stat-card {
  background: rgba(224, 242, 254, 0.5);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  padding: 24px;
  border-radius: 16px;
  box-shadow: 
    0 15px 30px rgba(59, 130, 246, 0.12),
    0 3px 8px rgba(59, 130, 246, 0.08);
  display: flex;
  align-items: center;
  gap: 16px;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(147, 197, 253, 0.4);
}

.stat-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, var(--card-color), var(--card-color-light));
}

.stat-card.primary::before { 
  background: linear-gradient(90deg, #3b82f6 0%, #06b6d4 100%);
}
.stat-card.success::before { 
  background: linear-gradient(90deg, #10b981 0%, #22c55e 100%);
}
.stat-card.info::before { 
  background: linear-gradient(90deg, #06b6d4 0%, #0ea5e9 100%);
}
.stat-card.warning::before { 
  background: linear-gradient(90deg, #f59e0b 0%, #eab308 100%);
}
.stat-card.danger::before { 
  background: linear-gradient(90deg, #ef4444 0%, #f97316 100%);
}
.stat-card.secondary::before { 
  background: linear-gradient(90deg, #6b7280 0%, #8b5cf6 100%);
}

.stat-card:hover {
  transform: translateY(-6px) scale(1.02);
  background: rgba(191, 219, 254, 0.6);
  box-shadow: 
    0 25px 50px rgba(59, 130, 246, 0.2),
    0 8px 20px rgba(59, 130, 246, 0.15);
  border: 1px solid rgba(147, 197, 253, 0.6);
}

.stat-icon {
  font-size: 2.5rem;
  width: 70px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 18px;
  background: linear-gradient(135deg, var(--card-color, #3b82f6), var(--card-color-light, #06b6d4));
  color: white;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.stat-card.primary .stat-icon { 
  background: linear-gradient(135deg, #3b82f6 0%, #06b6d4 100%);
}
.stat-card.success .stat-icon { 
  background: linear-gradient(135deg, #10b981 0%, #22c55e 100%);
}
.stat-card.info .stat-icon { 
  background: linear-gradient(135deg, #06b6d4 0%, #0ea5e9 100%);
}
.stat-card.warning .stat-icon { 
  background: linear-gradient(135deg, #f59e0b 0%, #eab308 100%);
}
.stat-card.danger .stat-icon { 
  background: linear-gradient(135deg, #ef4444 0%, #f97316 100%);
}
.stat-card.secondary .stat-icon { 
  background: linear-gradient(135deg, #6b7280 0%, #8b5cf6 100%);
}

.stat-content h3 {
  margin: 0 0 4px 0;
  font-size: 2rem;
  font-weight: 700;
  color: #1f2937;
}

.stat-content p {
  margin: 0;
  color: #6b7280;
  font-weight: 500;
}

.stat-trend {
  margin-left: auto;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 0.875rem;
  font-weight: 600;
}

.stat-trend.positive {
  background: #dcfce7;
  color: #166534;
}

.stat-trend.negative {
  background: #fee2e2;
  color: #991b1b;
}

.stat-trend.neutral {
  background: #f3f4f6;
  color: #374151;
}

/* Dashboard Tabs */
.dashboard-tabs {
  display: flex;
  gap: 8px;
  margin-bottom: 30px;
  background: rgba(219, 234, 254, 0.5);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  padding: 8px;
  border-radius: 12px;
  box-shadow: 
    0 8px 20px rgba(59, 130, 246, 0.1),
    0 2px 6px rgba(59, 130, 246, 0.08);
  border: 1px solid rgba(147, 197, 253, 0.3);
}

.tab-btn {
  flex: 1 1;
  padding: 12px 20px;
  border: none;
  background: transparent;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
  color: #6b7280;
  transition: all 0.3s ease;
}

.tab-btn.active {
  background: linear-gradient(135deg, #3b82f6, #1d4ed8);
  color: white;
  box-shadow: 0 4px 15px rgba(59, 130, 246, 0.3);
}

.tab-btn:hover:not(.active) {
  background: rgba(59, 130, 246, 0.1);
  color: #3b82f6;
}

/* Tab Content */
.tab-content {
  background: rgba(224, 242, 254, 0.4);
  backdrop-filter: blur(15px);
  -webkit-backdrop-filter: blur(15px);
  border-radius: 16px;
  padding: 30px;
  box-shadow: 
    0 15px 35px rgba(59, 130, 246, 0.12),
    0 3px 8px rgba(59, 130, 246, 0.08);
  border: 1px solid rgba(147, 197, 253, 0.4);
}

.overview-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 30px;
}

.chart-card {
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
}

.chart-card.full-width {
  grid-column: 1 / -1;
}

.chart-card h3 {
  margin: 0 0 20px 0;
  color: #1f2937;
  font-weight: 600;
}

.chart-container {
  height: 300px;
  position: relative;
}

.chart-container.large {
  height: 400px;
}

/* Analytics Section */
.analytics-section {
  width: 100%;
}

/* Filters Section */
.filters-section {
  width: 100%;
}

.filter-controls {
  margin-bottom: 30px;
}

.filter-controls h3 {
  margin: 0 0 20px 0;
  color: #1f2937;
  font-weight: 600;
}

.filter-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.filter-btn {
  padding: 10px 20px;
  border: 2px solid #e5e7eb;
  background: white;
  border-radius: 25px;
  cursor: pointer;
  font-weight: 500;
  color: #6b7280;
  transition: all 0.3s ease;
}

.filter-btn.active {
  background: linear-gradient(135deg, #3b82f6, #1d4ed8);
  border-color: #3b82f6;
  color: white;
  box-shadow: 0 4px 15px rgba(59, 130, 246, 0.3);
}

.filter-btn:hover:not(.active) {
  border-color: #3b82f6;
  color: #3b82f6;
}

.filtered-results {
  margin-top: 30px;
}

.results-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.results-header h4 {
  margin: 0;
  color: #1f2937;
  font-weight: 600;
}

.results-summary {
  color: #6b7280;
  font-size: 0.875rem;
}

/* Applicants Table */
.applicants-table {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
}

.applicants-table table {
  width: 100%;
  border-collapse: collapse;
}

.applicants-table th {
  background: #f9fafb;
  padding: 16px 12px;
  text-align: left;
  font-weight: 600;
  color: #374151;
  border-bottom: 1px solid #e5e7eb;
}

.applicants-table td {
  padding: 16px 12px;
  border-bottom: 1px solid #f3f4f6;
}

.applicant-row:hover {
  background: #f9fafb;
}

.ats-number {
  font-family: 'Courier New', monospace;
  font-weight: 600;
  color: #3b82f6;
}

.applicant-name strong {
  color: #1f2937;
}

.email {
  color: #6b7280;
  font-size: 0.875rem;
}

.domain, .source {
  background: #f3f4f6;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 0.875rem;
  color: #374151;
}

.date {
  color: #6b7280;
  font-size: 0.875rem;
}

.status-badges {
  display: flex;
  gap: 4px;
}

.status-badge {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  color: white;
}

.status-badge.attended { background: #10b981; }
.status-badge.registered { background: #3b82f6; }
.status-badge.assigned { background: #8b5cf6; }
.status-badge.rejected { background: #ef4444; }
.status-badge.left { background: #f59e0b; }

/* Recent Section */
.recent-section {
  width: 100%;
}

.recent-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.recent-header h3 {
  margin: 0;
  color: #1f2937;
  font-weight: 600;
}

.recent-count {
  background: #f3f4f6;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 0.875rem;
  color: #6b7280;
  font-weight: 500;
}

.recent-applications {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 20px;
}

.recent-card {
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.recent-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
}

.recent-card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 16px;
}

.applicant-info h4 {
  margin: 0 0 4px 0;
  color: #1f2937;
  font-weight: 600;
}

.application-date {
  background: #f3f4f6;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 0.875rem;
  color: #6b7280;
}

.recent-card-body {
  margin-bottom: 16px;
}

.contact-info {
  margin-bottom: 8px;
}

.contact-info .email {
  color: #3b82f6;
  font-weight: 500;
}

.details {
  display: flex;
  gap: 12px;
}

.details .domain,
.details .source {
  background: #f3f4f6;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 0.875rem;
  color: #374151;
}

.recent-card-footer {
  display: flex;
  justify-content: flex-end;
}

.status-indicators {
  display: flex;
  gap: 8px;
}

.status-indicator {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.875rem;
  color: white;
  cursor: help;
}

.status-indicator.attended { background: #10b981; }
.status-indicator.registered { background: #3b82f6; }
.status-indicator.assigned { background: #8b5cf6; }
.status-indicator.rejected { background: #ef4444; }
.status-indicator.left { background: #f59e0b; }

/* Loading State */
.dashboard-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  /* Match ATS app background */
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  position: relative;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
}

.dashboard-loading::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: 
    radial-gradient(circle at 20% 50%, rgba(59, 130, 246, 0.1) 0%, transparent 60%),
    radial-gradient(circle at 80% 20%, rgba(6, 182, 212, 0.08) 0%, transparent 55%),
    radial-gradient(circle at 40% 80%, rgba(34, 197, 94, 0.06) 0%, transparent 50%),
    radial-gradient(circle at 70% 60%, rgba(139, 92, 246, 0.07) 0%, transparent 45%);
  pointer-events: none;
}

.dashboard-loading > * {
  position: relative;
  z-index: 1;
}

.loading-spinner {
  width: 60px;
  height: 60px;
  border: 4px solid rgba(59, 130, 246, 0.2);
  border-top: 4px solid #3b82f6;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 24px;
  box-shadow: 0 8px 20px rgba(59, 130, 246, 0.1);
}

.dashboard-loading p {
  color: #1e40af;
  font-size: 1.1rem;
  font-weight: 600;
  margin: 0;
  text-shadow: 0 1px 2px rgba(59, 130, 246, 0.1);
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Responsive Design */
@media (max-width: 768px) {
  .dashboard-container {
    padding: 10px;
  }

  .dashboard-header {
    flex-direction: column;
    gap: 15px;
    text-align: center;
  }

  .dashboard-header h1 {
    font-size: 1.5rem;
  }

  .header-actions {
    flex-direction: column;
    gap: 10px;
  }

  .stats-grid {
    grid-template-columns: 1fr;
    gap: 15px;
  }

  .stat-card {
    padding: 20px;
  }

  .stat-icon {
    width: 50px;
    height: 50px;
    font-size: 2rem;
  }

  .stat-content h3 {
    font-size: 1.5rem;
  }

  .dashboard-tabs {
    flex-direction: column;
  }

  .tab-btn {
    text-align: center;
  }

  .tab-content {
    padding: 20px;
  }

  .overview-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .chart-container {
    height: 250px;
  }

  .chart-container.large {
    height: 300px;
  }

  .filter-buttons {
    justify-content: center;
  }

  .applicants-table {
    overflow-x: auto;
  }

  .applicants-table table {
    min-width: 600px;
  }

  .recent-applications {
    grid-template-columns: 1fr;
  }

  .recent-card-header {
    flex-direction: column;
    gap: 10px;
    align-items: flex-start;
  }
}

@media (max-width: 480px) {
  .stat-card {
    flex-direction: column;
    text-align: center;
    gap: 12px;
  }

  .stat-trend {
    margin-left: 0;
  }

  .filter-buttons {
    flex-direction: column;
  }

  .filter-btn {
    text-align: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/Dashboard.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;EACE,aAAa;EACb,oGAAoG;EACpG,iBAAiB;EACjB,mEAAmE;EACnE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;;;oFAIkF;EAClF,oBAAoB;AACtB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oCAAoC;EACpC,2BAA2B;EAC3B,mCAAmC;EACnC,kBAAkB;EAClB,mBAAmB;EACnB;;qCAEmC;EACnC,0CAA0C;EAC1C,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,0EAA0E;EAC1E,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB;;gCAE8B;EAC9B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,6DAA6D;EAC7D;;iCAE+B;AACjC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,oCAAoC;EACpC,0BAA0B;EAC1B,kCAAkC;EAClC,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,iBAAiB;AACnB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB;;sCAEoC;EACpC,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,8EAA8E;AAChF;;AAEA;EACE,4DAA4D;AAC9D;AACA;EACE,4DAA4D;AAC9D;AACA;EACE,4DAA4D;AAC9D;AACA;EACE,4DAA4D;AAC9D;AACA;EACE,4DAA4D;AAC9D;AACA;EACE,4DAA4D;AAC9D;;AAEA;EACE,uCAAuC;EACvC,oCAAoC;EACpC;;uCAEqC;EACrC,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,iGAAiG;EACjG,YAAY;EACZ,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;AAC/D;AACA;EACE,6DAA6D;AAC/D;AACA;EACE,6DAA6D;AAC/D;AACA;EACE,6DAA6D;AAC/D;AACA;EACE,6DAA6D;AAC/D;AACA;EACE,6DAA6D;AAC/D;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,oCAAoC;EACpC,2BAA2B;EAC3B,mCAAmC;EACnC,YAAY;EACZ,mBAAmB;EACnB;;sCAEoC;EACpC,0CAA0C;AAC5C;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;EACnB,aAAa;EACb;;sCAEoC;EACpC,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA,sBAAsB;AACtB;EACE,WAAW;AACb;;AAEA,oBAAoB;AACpB;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,qDAAqD;EACrD,qBAAqB;EACrB,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;AACd;;AAEA,yBAAyB,mBAAmB,EAAE;AAC9C,2BAA2B,mBAAmB,EAAE;AAChD,yBAAyB,mBAAmB,EAAE;AAC9C,yBAAyB,mBAAmB,EAAE;AAC9C,qBAAqB,mBAAmB,EAAE;;AAE1C,mBAAmB;AACnB;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;EAEE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA,6BAA6B,mBAAmB,EAAE;AAClD,+BAA+B,mBAAmB,EAAE;AACpD,6BAA6B,mBAAmB,EAAE;AAClD,6BAA6B,mBAAmB,EAAE;AAClD,yBAAyB,mBAAmB,EAAE;;AAE9C,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,6BAA6B;EAC7B,6DAA6D;EAC7D,kBAAkB;EAClB,mEAAmE;AACrE;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;;;oFAIkF;EAClF,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,8CAA8C;AAChD;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":["/* Dashboard Container */\n.dashboard-container {\n  padding: 20px;\n  background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 25%, #e0f2fe 50%, #cffafe 75%, #dbeafe 100%);\n  min-height: 100vh;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;\n  position: relative;\n}\n\n.dashboard-container::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: \n    radial-gradient(circle at 20% 50%, rgba(59, 130, 246, 0.1) 0%, transparent 60%),\n    radial-gradient(circle at 80% 20%, rgba(6, 182, 212, 0.08) 0%, transparent 55%),\n    radial-gradient(circle at 40% 80%, rgba(34, 197, 94, 0.06) 0%, transparent 50%),\n    radial-gradient(circle at 70% 60%, rgba(139, 92, 246, 0.07) 0%, transparent 45%);\n  pointer-events: none;\n}\n\n/* Dashboard Header */\n.dashboard-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 30px;\n  background: rgba(219, 234, 254, 0.6);\n  backdrop-filter: blur(15px);\n  -webkit-backdrop-filter: blur(15px);\n  padding: 25px 35px;\n  border-radius: 20px;\n  box-shadow: \n    0 20px 40px rgba(59, 130, 246, 0.15),\n    0 1px 3px rgba(59, 130, 246, 0.1);\n  border: 1px solid rgba(147, 197, 253, 0.3);\n  position: relative;\n  z-index: 1;\n}\n\n.dashboard-header h1 {\n  margin: 0;\n  background: linear-gradient(135deg, #1e3a8a 0%, #1e40af 50%, #3b82f6 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  font-size: 2.2rem;\n  font-weight: 800;\n  letter-spacing: -0.5px;\n  text-shadow: 0 2px 4px rgba(59, 130, 246, 0.1);\n}\n\n.header-actions {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n.refresh-btn {\n  background: linear-gradient(135deg, #3b82f6 0%, #06b6d4 100%);\n  color: white;\n  border: none;\n  padding: 14px 24px;\n  border-radius: 14px;\n  cursor: pointer;\n  font-weight: 700;\n  font-size: 0.95rem;\n  transition: all 0.3s ease;\n  box-shadow: \n    0 8px 20px rgba(59, 130, 246, 0.25),\n    0 2px 4px rgba(0, 0, 0, 0.1);\n  position: relative;\n  overflow: hidden;\n}\n\n.refresh-btn:hover {\n  transform: translateY(-3px) scale(1.02);\n  background: linear-gradient(135deg, #2563eb 0%, #0891b2 100%);\n  box-shadow: \n    0 12px 30px rgba(59, 130, 246, 0.35),\n    0 4px 8px rgba(0, 0, 0, 0.15);\n}\n\n.date-display {\n  color: #1e40af;\n  font-weight: 700;\n  background: rgba(147, 197, 253, 0.4);\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n  padding: 10px 16px;\n  border-radius: 12px;\n  border: 1px solid rgba(147, 197, 253, 0.3);\n  font-size: 0.9rem;\n}\n\n/* Stats Grid */\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 20px;\n  margin-bottom: 30px;\n}\n\n.stat-card {\n  background: rgba(224, 242, 254, 0.5);\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n  padding: 24px;\n  border-radius: 16px;\n  box-shadow: \n    0 15px 30px rgba(59, 130, 246, 0.12),\n    0 3px 8px rgba(59, 130, 246, 0.08);\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  transition: all 0.3s ease;\n  position: relative;\n  overflow: hidden;\n  border: 1px solid rgba(147, 197, 253, 0.4);\n}\n\n.stat-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: linear-gradient(90deg, var(--card-color), var(--card-color-light));\n}\n\n.stat-card.primary::before { \n  background: linear-gradient(90deg, #3b82f6 0%, #06b6d4 100%);\n}\n.stat-card.success::before { \n  background: linear-gradient(90deg, #10b981 0%, #22c55e 100%);\n}\n.stat-card.info::before { \n  background: linear-gradient(90deg, #06b6d4 0%, #0ea5e9 100%);\n}\n.stat-card.warning::before { \n  background: linear-gradient(90deg, #f59e0b 0%, #eab308 100%);\n}\n.stat-card.danger::before { \n  background: linear-gradient(90deg, #ef4444 0%, #f97316 100%);\n}\n.stat-card.secondary::before { \n  background: linear-gradient(90deg, #6b7280 0%, #8b5cf6 100%);\n}\n\n.stat-card:hover {\n  transform: translateY(-6px) scale(1.02);\n  background: rgba(191, 219, 254, 0.6);\n  box-shadow: \n    0 25px 50px rgba(59, 130, 246, 0.2),\n    0 8px 20px rgba(59, 130, 246, 0.15);\n  border: 1px solid rgba(147, 197, 253, 0.6);\n}\n\n.stat-icon {\n  font-size: 2.5rem;\n  width: 70px;\n  height: 70px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 18px;\n  background: linear-gradient(135deg, var(--card-color, #3b82f6), var(--card-color-light, #06b6d4));\n  color: white;\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);\n  transition: all 0.3s ease;\n}\n\n.stat-card.primary .stat-icon { \n  background: linear-gradient(135deg, #3b82f6 0%, #06b6d4 100%);\n}\n.stat-card.success .stat-icon { \n  background: linear-gradient(135deg, #10b981 0%, #22c55e 100%);\n}\n.stat-card.info .stat-icon { \n  background: linear-gradient(135deg, #06b6d4 0%, #0ea5e9 100%);\n}\n.stat-card.warning .stat-icon { \n  background: linear-gradient(135deg, #f59e0b 0%, #eab308 100%);\n}\n.stat-card.danger .stat-icon { \n  background: linear-gradient(135deg, #ef4444 0%, #f97316 100%);\n}\n.stat-card.secondary .stat-icon { \n  background: linear-gradient(135deg, #6b7280 0%, #8b5cf6 100%);\n}\n\n.stat-content h3 {\n  margin: 0 0 4px 0;\n  font-size: 2rem;\n  font-weight: 700;\n  color: #1f2937;\n}\n\n.stat-content p {\n  margin: 0;\n  color: #6b7280;\n  font-weight: 500;\n}\n\n.stat-trend {\n  margin-left: auto;\n  padding: 6px 12px;\n  border-radius: 20px;\n  font-size: 0.875rem;\n  font-weight: 600;\n}\n\n.stat-trend.positive {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.stat-trend.negative {\n  background: #fee2e2;\n  color: #991b1b;\n}\n\n.stat-trend.neutral {\n  background: #f3f4f6;\n  color: #374151;\n}\n\n/* Dashboard Tabs */\n.dashboard-tabs {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 30px;\n  background: rgba(219, 234, 254, 0.5);\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n  padding: 8px;\n  border-radius: 12px;\n  box-shadow: \n    0 8px 20px rgba(59, 130, 246, 0.1),\n    0 2px 6px rgba(59, 130, 246, 0.08);\n  border: 1px solid rgba(147, 197, 253, 0.3);\n}\n\n.tab-btn {\n  flex: 1;\n  padding: 12px 20px;\n  border: none;\n  background: transparent;\n  border-radius: 8px;\n  cursor: pointer;\n  font-weight: 600;\n  color: #6b7280;\n  transition: all 0.3s ease;\n}\n\n.tab-btn.active {\n  background: linear-gradient(135deg, #3b82f6, #1d4ed8);\n  color: white;\n  box-shadow: 0 4px 15px rgba(59, 130, 246, 0.3);\n}\n\n.tab-btn:hover:not(.active) {\n  background: rgba(59, 130, 246, 0.1);\n  color: #3b82f6;\n}\n\n/* Tab Content */\n.tab-content {\n  background: rgba(224, 242, 254, 0.4);\n  backdrop-filter: blur(15px);\n  -webkit-backdrop-filter: blur(15px);\n  border-radius: 16px;\n  padding: 30px;\n  box-shadow: \n    0 15px 35px rgba(59, 130, 246, 0.12),\n    0 3px 8px rgba(59, 130, 246, 0.08);\n  border: 1px solid rgba(147, 197, 253, 0.4);\n}\n\n.overview-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));\n  gap: 30px;\n}\n\n.chart-card {\n  background: white;\n  border-radius: 12px;\n  padding: 24px;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);\n}\n\n.chart-card.full-width {\n  grid-column: 1 / -1;\n}\n\n.chart-card h3 {\n  margin: 0 0 20px 0;\n  color: #1f2937;\n  font-weight: 600;\n}\n\n.chart-container {\n  height: 300px;\n  position: relative;\n}\n\n.chart-container.large {\n  height: 400px;\n}\n\n/* Analytics Section */\n.analytics-section {\n  width: 100%;\n}\n\n/* Filters Section */\n.filters-section {\n  width: 100%;\n}\n\n.filter-controls {\n  margin-bottom: 30px;\n}\n\n.filter-controls h3 {\n  margin: 0 0 20px 0;\n  color: #1f2937;\n  font-weight: 600;\n}\n\n.filter-buttons {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n.filter-btn {\n  padding: 10px 20px;\n  border: 2px solid #e5e7eb;\n  background: white;\n  border-radius: 25px;\n  cursor: pointer;\n  font-weight: 500;\n  color: #6b7280;\n  transition: all 0.3s ease;\n}\n\n.filter-btn.active {\n  background: linear-gradient(135deg, #3b82f6, #1d4ed8);\n  border-color: #3b82f6;\n  color: white;\n  box-shadow: 0 4px 15px rgba(59, 130, 246, 0.3);\n}\n\n.filter-btn:hover:not(.active) {\n  border-color: #3b82f6;\n  color: #3b82f6;\n}\n\n.filtered-results {\n  margin-top: 30px;\n}\n\n.results-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.results-header h4 {\n  margin: 0;\n  color: #1f2937;\n  font-weight: 600;\n}\n\n.results-summary {\n  color: #6b7280;\n  font-size: 0.875rem;\n}\n\n/* Applicants Table */\n.applicants-table {\n  background: white;\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);\n}\n\n.applicants-table table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.applicants-table th {\n  background: #f9fafb;\n  padding: 16px 12px;\n  text-align: left;\n  font-weight: 600;\n  color: #374151;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.applicants-table td {\n  padding: 16px 12px;\n  border-bottom: 1px solid #f3f4f6;\n}\n\n.applicant-row:hover {\n  background: #f9fafb;\n}\n\n.ats-number {\n  font-family: 'Courier New', monospace;\n  font-weight: 600;\n  color: #3b82f6;\n}\n\n.applicant-name strong {\n  color: #1f2937;\n}\n\n.email {\n  color: #6b7280;\n  font-size: 0.875rem;\n}\n\n.domain, .source {\n  background: #f3f4f6;\n  padding: 4px 8px;\n  border-radius: 6px;\n  font-size: 0.875rem;\n  color: #374151;\n}\n\n.date {\n  color: #6b7280;\n  font-size: 0.875rem;\n}\n\n.status-badges {\n  display: flex;\n  gap: 4px;\n}\n\n.status-badge {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.75rem;\n  color: white;\n}\n\n.status-badge.attended { background: #10b981; }\n.status-badge.registered { background: #3b82f6; }\n.status-badge.assigned { background: #8b5cf6; }\n.status-badge.rejected { background: #ef4444; }\n.status-badge.left { background: #f59e0b; }\n\n/* Recent Section */\n.recent-section {\n  width: 100%;\n}\n\n.recent-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.recent-header h3 {\n  margin: 0;\n  color: #1f2937;\n  font-weight: 600;\n}\n\n.recent-count {\n  background: #f3f4f6;\n  padding: 6px 12px;\n  border-radius: 20px;\n  font-size: 0.875rem;\n  color: #6b7280;\n  font-weight: 500;\n}\n\n.recent-applications {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));\n  gap: 20px;\n}\n\n.recent-card {\n  background: white;\n  border-radius: 12px;\n  padding: 20px;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);\n  transition: all 0.3s ease;\n}\n\n.recent-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);\n}\n\n.recent-card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 16px;\n}\n\n.applicant-info h4 {\n  margin: 0 0 4px 0;\n  color: #1f2937;\n  font-weight: 600;\n}\n\n.application-date {\n  background: #f3f4f6;\n  padding: 4px 8px;\n  border-radius: 6px;\n  font-size: 0.875rem;\n  color: #6b7280;\n}\n\n.recent-card-body {\n  margin-bottom: 16px;\n}\n\n.contact-info {\n  margin-bottom: 8px;\n}\n\n.contact-info .email {\n  color: #3b82f6;\n  font-weight: 500;\n}\n\n.details {\n  display: flex;\n  gap: 12px;\n}\n\n.details .domain,\n.details .source {\n  background: #f3f4f6;\n  padding: 4px 8px;\n  border-radius: 6px;\n  font-size: 0.875rem;\n  color: #374151;\n}\n\n.recent-card-footer {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.status-indicators {\n  display: flex;\n  gap: 8px;\n}\n\n.status-indicator {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.875rem;\n  color: white;\n  cursor: help;\n}\n\n.status-indicator.attended { background: #10b981; }\n.status-indicator.registered { background: #3b82f6; }\n.status-indicator.assigned { background: #8b5cf6; }\n.status-indicator.rejected { background: #ef4444; }\n.status-indicator.left { background: #f59e0b; }\n\n/* Loading State */\n.dashboard-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100vh;\n  /* Match ATS app background */\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  position: relative;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n.dashboard-loading::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: \n    radial-gradient(circle at 20% 50%, rgba(59, 130, 246, 0.1) 0%, transparent 60%),\n    radial-gradient(circle at 80% 20%, rgba(6, 182, 212, 0.08) 0%, transparent 55%),\n    radial-gradient(circle at 40% 80%, rgba(34, 197, 94, 0.06) 0%, transparent 50%),\n    radial-gradient(circle at 70% 60%, rgba(139, 92, 246, 0.07) 0%, transparent 45%);\n  pointer-events: none;\n}\n\n.dashboard-loading > * {\n  position: relative;\n  z-index: 1;\n}\n\n.loading-spinner {\n  width: 60px;\n  height: 60px;\n  border: 4px solid rgba(59, 130, 246, 0.2);\n  border-top: 4px solid #3b82f6;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 24px;\n  box-shadow: 0 8px 20px rgba(59, 130, 246, 0.1);\n}\n\n.dashboard-loading p {\n  color: #1e40af;\n  font-size: 1.1rem;\n  font-weight: 600;\n  margin: 0;\n  text-shadow: 0 1px 2px rgba(59, 130, 246, 0.1);\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .dashboard-container {\n    padding: 10px;\n  }\n\n  .dashboard-header {\n    flex-direction: column;\n    gap: 15px;\n    text-align: center;\n  }\n\n  .dashboard-header h1 {\n    font-size: 1.5rem;\n  }\n\n  .header-actions {\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .stats-grid {\n    grid-template-columns: 1fr;\n    gap: 15px;\n  }\n\n  .stat-card {\n    padding: 20px;\n  }\n\n  .stat-icon {\n    width: 50px;\n    height: 50px;\n    font-size: 2rem;\n  }\n\n  .stat-content h3 {\n    font-size: 1.5rem;\n  }\n\n  .dashboard-tabs {\n    flex-direction: column;\n  }\n\n  .tab-btn {\n    text-align: center;\n  }\n\n  .tab-content {\n    padding: 20px;\n  }\n\n  .overview-grid {\n    grid-template-columns: 1fr;\n    gap: 20px;\n  }\n\n  .chart-container {\n    height: 250px;\n  }\n\n  .chart-container.large {\n    height: 300px;\n  }\n\n  .filter-buttons {\n    justify-content: center;\n  }\n\n  .applicants-table {\n    overflow-x: auto;\n  }\n\n  .applicants-table table {\n    min-width: 600px;\n  }\n\n  .recent-applications {\n    grid-template-columns: 1fr;\n  }\n\n  .recent-card-header {\n    flex-direction: column;\n    gap: 10px;\n    align-items: flex-start;\n  }\n}\n\n@media (max-width: 480px) {\n  .stat-card {\n    flex-direction: column;\n    text-align: center;\n    gap: 12px;\n  }\n\n  .stat-trend {\n    margin-left: 0;\n  }\n\n  .filter-buttons {\n    flex-direction: column;\n  }\n\n  .filter-btn {\n    text-align: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
